// "preview" runs the whole learner journey on this device only, with a
// development-only release button standing in for the Teacher App.
// "live" reads and writes through the learner gateway.
export const DATA_MODE =
  process.env.REACT_APP_DATA_MODE === "live" ? "live" : "preview";

export const IS_PREVIEW = DATA_MODE === "preview";

// The learner gateway (gateway/): the only server this app talks to in live
// mode. It holds the tablet's learner in an httpOnly cookie of its own; this
// app never holds a Directus credential of any kind. It must be set at build
// time; there is deliberately no fallback to this app's own address.
export const GATEWAY_URL = (process.env.REACT_APP_GATEWAY_URL || "").replace(
  /\/$/,
  ""
);

// How often the waiting screen checks whether the teacher has released the
// activity. A few seconds is acceptable (handoff §9).
export const POLL_MS = Number(process.env.REACT_APP_POLL_MS) || 4000;

// "Your turn" is a brief hand-off cue, not a second permission gate. The
// attempt begins only when this cue yields to the first interactive screen.
export const YOUR_TURN_MS = Number(process.env.REACT_APP_YOUR_TURN_MS) || 1800;
